import React from 'react';
import { useTranslation } from 'react-i18next';

const BillingDetailHeader = () => {
   // translations
  const tLabels = useTranslation(["billings\\billings"]).t;

  return (
    <div className="d-none d-lg-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters">
        <div className="col-6">
          {tLabels("billingDetailHeader.item")}
        </div>
        <div className="col-2 text-right">
          {tLabels("billingDetailHeader.quantity")}
        </div>
        <div className="col-2 text-right" title="Jednotková cena">
          {tLabels("billingDetailHeader.unitPrice")}
        </div>
        <div className="col-2 text-right">
          {tLabels("billingDetailHeader.total")}
        </div>
      </div>
    </div>
  )
}

export default BillingDetailHeader;
